var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-ads"},_vm._l((_vm.adSections),function(adSection,index){return _c('div',{key:index,staticClass:"sidebar-ads__placeholder"},[_c('ad-slot',_vm._b({attrs:{"sticky":""}},'ad-slot',adSection.options,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }